import React from "react";
import { Button } from "primereact/button";

export const appPageContainerStyle = {
  width: "100%",
  maxWidth: "100%",
  margin: "0 auto",
} as const;

export const appSectionCardStyle = {
  border: "1px solid #e3edf5",
  boxShadow: "0 14px 32px rgba(24, 93, 162, 0.08)",
  borderRadius: "16px",
} as const;

export const appNeutralPanelStyle = {
  backgroundColor: "#f8fafc",
  border: "1px solid #e2e8f0",
  borderRadius: "16px",
  padding: "1.25rem",
} as const;

export const appAccentPanelStyle = {
  background: "linear-gradient(180deg, #fff7ed 0%, #ffffff 100%)",
  border: "1px solid #fdba74",
  borderRadius: "16px",
  padding: "1.25rem",
} as const;

export const appDialogStyle = {
  width: "50rem",
  maxWidth: "95vw",
} as const;

export const appWideDialogStyle = {
  width: "72rem",
  maxWidth: "95vw",
} as const;

export const appFullDialogStyle = {
  width: "96vw",
  maxWidth: "1100px",
} as const;

export const appDialogContentStyle = {
  background: "#f8fafc",
  padding: "1.25rem",
} as const;

export const appDialogHeaderStyle = {
  padding: "1.25rem 1.25rem 0.75rem",
  background: "linear-gradient(180deg, #fffaf0 0%, #ffffff 100%)",
  borderBottom: "1px solid #f3e8d3",
} as const;

export const appDialogFooterStyle = {
  padding: "0.75rem 1.25rem 1.25rem",
  background: "#ffffff",
  borderTop: "1px solid #edf2f7",
} as const;

export const appFormSectionStyle = {
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  borderRadius: "16px",
  padding: "1.25rem",
} as const;

export const appMutedTextStyle = {
  color: "#64748b",
  lineHeight: 1.6,
} as const;

export const appDataTableWrapperStyle = {
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  borderRadius: "16px",
  overflow: "hidden",
  overflowX: "auto",
} as const;

export const appInnerCardStyle = {
  ...appFormSectionStyle,
  boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
} as const;

export const renderSurfaceHeader = (
  title: string,
  subtitle?: string,
  icon?: string,
) => (
  <div className="flex align-items-start gap-3">
    {icon ? (
      <div
        className={icon}
        style={{
          color: "#185DA2",
          background: "#e0f2fe",
          borderRadius: "999px",
          padding: "0.85rem",
          fontSize: "1rem",
        }}
      />
    ) : null}
    <div>
      <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}>{title}</div>
      {subtitle ? <div className="mt-1" style={appMutedTextStyle}>{subtitle}</div> : null}
    </div>
  </div>
);

export const renderDialogFooter = ({
  errorMessage,
  loading,
  onCancel,
  onSubmit,
  submitLabel = "Save",
  cancelButtonProps,
  submitButtonProps,
}: {
  errorMessage?: string | null;
  loading?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel?: string;
  cancelButtonProps?: any;
  submitButtonProps?: any;
}) => (
  <div className="flex flex-column gap-3">
    {errorMessage ? <div className="p-error">{errorMessage}</div> : null}
    <div className="flex justify-content-end gap-2">
      <Button label="Close" severity="secondary" outlined onClick={onCancel} {...cancelButtonProps} />
      <Button label={submitLabel} severity="warning" rounded loading={loading} onClick={onSubmit} {...submitButtonProps} />
    </div>
  </div>
);

export const renderConfirmMessage = (
  title: string,
  description: string,
) => (
  <div style={{ ...appAccentPanelStyle, maxWidth: "32rem" }}>
    <div style={{ fontWeight: 700, color: "#9a3412" }}>{title}</div>
    <div
      className="mt-2"
      style={{
        ...appMutedTextStyle,
        whiteSpace: "pre-line",
        lineHeight: 1.7,
      }}
    >
      {description}
    </div>
  </div>
);

export const appConfirmDialogClasses = {
  acceptClassName: "p-button-warning p-button-outlined p-button-rounded",
  rejectClassName: "p-button-secondary p-button-outlined p-button-rounded",
} as const;
